import { InputAdornment, SvgIcon, TextField } from '@mui/material';
import SearchIcon from 'assets/icons/search.svg';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';

const SearchField = ({ inputProps = {}, InputProps = {}, slotProps = {}, ...props }) => {
  const inputSlotProps = slotProps.input ?? {};
  const htmlInputSlotProps = slotProps.htmlInput ?? {};
  return (
    <TextField
      autoComplete="off"
      name="search"
      type="search"
      fullWidth
      slotProps={{
        ...slotProps,
        htmlInput: {
          results: 5,
          ...inputProps,
          ...htmlInputSlotProps,
        },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SvgIcon
                sx={{
                  pt: '3px',
                  fontSize: 20,
                  fontWeight: 'normal',
                  color: 'secondary.main',
                }}
              >
                <SearchIcon />
              </SvgIcon>
            </InputAdornment>
          ),
          ...InputProps,
          ...inputSlotProps,
          sx: theme => ({
            border: 0,
            pr: 0,
            pl: 0,
            borderColor: theme.palette.secondary.light,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.secondary.light,
            },
            '& input': {
              height: 16,
              '&::-webkit-search-cancel-button': {
                WebkitAppearance: 'none',
                width: '1.2rem',
                height: '1.2rem',
                backgroundSize: 'cover',
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='${encodeURIComponent(
                  theme.palette.secondary.main,
                )}' viewBox='0 0 512 512'%3E%3Cpath d='M400 145.49L366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z'/%3E%3C/svg%3E")`,
              },
              '&::placeholder': {
                color: theme.palette.secondary.main,
              },
            },
            ...(inputSlotProps.sx || {}),
            ...(InputProps.sx || {}),
          }),
        },
      }}
      placeholder={I18n.t('SearchField.search')}
      {...props}
    />
  );
};

SearchField.propTypes = {
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  slotProps: PropTypes.object,
};

export default memo(SearchField);
